






















import { Component, Vue } from 'vue-property-decorator';

// Vue elements
import GameVue from '../components/Game.vue';
import PuzzleTestVue from '../components/puzzles/PuzzleTest.vue';

// Engine elements
import Game from '../../engine/Game';
//import createGame from '@/games/game';
//import createTest from '../../games/test';

import Preloader from '../../utils/preloader';
import sleep from '../../utils/sleep';

@Component({
    components: {
        GameVue,
        PuzzleTestVue
    },
})
export default class GamePage extends Vue {

    loaded = false;
    game: Game|null = null;

    mounted(){

        this.waitLoad();

    }

    async waitLoad(){

        await Preloader.preloadFolder('fonts');
        await Preloader.preloadFolder('base');
        await Preloader.preloadFolder('puzzles');
        this.loaded = true;

        try {
            this.game = await Game.current();
        } catch(e){
            console.error(e);
            this.$router.push('/');
        }


    }




}

